function cov_2gqi9gf653() {
  var path = "/app/src/utils/check-lang.tsx";
  var hash = "0f2d175d627796f62b94b984e05bd5ef4334ab92";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/utils/check-lang.tsx",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 25
        },
        end: {
          line: 20,
          column: 1
        }
      },
      "1": {
        start: {
          line: 13,
          column: 2
        },
        end: {
          line: 19,
          column: 3
        }
      },
      "2": {
        start: {
          line: 14,
          column: 4
        },
        end: {
          line: 14,
          column: 68
        }
      },
      "3": {
        start: {
          line: 17,
          column: 4
        },
        end: {
          line: 17,
          column: 79
        }
      },
      "4": {
        start: {
          line: 18,
          column: 4
        },
        end: {
          line: 18,
          column: 41
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 5,
            column: 25
          },
          end: {
            line: 5,
            column: 26
          }
        },
        loc: {
          start: {
            line: 12,
            column: 5
          },
          end: {
            line: 20,
            column: 1
          }
        },
        line: 12
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 14,
            column: 11
          },
          end: {
            line: 14,
            column: 67
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 14,
            column: 19
          },
          end: {
            line: 14,
            column: 37
          }
        }, {
          start: {
            line: 14,
            column: 40
          },
          end: {
            line: 14,
            column: 67
          }
        }],
        line: 14
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "0f2d175d627796f62b94b984e05bd5ef4334ab92"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2gqi9gf653 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2gqi9gf653();
import { dictionaryMapLanguage } from 'src/constants/dictionary-map-language';
import { getLangCode } from 'src/utils/get-lang-code';
cov_2gqi9gf653().s[0]++;
export var checkLang = function checkLang(value, _ref) {
  var locale = _ref.locale;
  cov_2gqi9gf653().f[0]++;
  cov_2gqi9gf653().s[1]++;
  try {
    cov_2gqi9gf653().s[2]++;
    return value ? (cov_2gqi9gf653().b[0][0]++, getLangCode(value)) : (cov_2gqi9gf653().b[0][1]++, getLangCode(locale));
  } catch (_unused) {
    cov_2gqi9gf653().s[3]++;
    // eslint-disable-next-line no-console
    console.warn('The lang parameter has an incorrect value. Please check it');
    cov_2gqi9gf653().s[4]++;
    return dictionaryMapLanguage.en.lang;
  }
};